@if (secondsLeft) {
<span class="auto-reload-countdown"> {{ secondsLeft }}s </span>
<fa-icon
  [class.flash-effect]="reloading"
  [icon]="rotateIcon"
  animation="spin"
></fa-icon>
} @if (cacheEnabled) {
<span class="pulse-effect">
  Cached
  <fa-icon
    [icon]="faBuffer"
    [suiTooltip]="'dashboard-auto-refresh-counter.tooltip.cache-enabled' | translate"
  ></fa-icon>
</span>
} @if (!cacheEnabled) {
<span class="pulse-effect">
  Live
  <fa-icon
    [icon]="faHeartPulse"
    [suiTooltip]="'dashboard-auto-refresh-counter.tooltip.cache-disabled' | translate"
  ></fa-icon>
</span>
}
